import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { notificationsSearchSchema } from '@/features/notifications/search-schema';
import { notificationKeys } from '@/features/notifications/queries';
import { NotificationsPendingState } from '@/features/notifications/NotificationsPendingState';
import { getUnreadCount } from '@/lib/notifications';
import { requireAuth } from '@/lib/route-guards';

export const notificationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/notifications',
  validateSearch: notificationsSearchSchema,
  beforeLoad: requireAuth,
  // Prime the unread-count so the topbar badge paints without a flash on first
  // navigation. The feed itself loads via the page's `useInfiniteQuery` (cursor
  // pagination). Swallow the error — the page renders its own loading/error/
  // retry states.
  loader: ({ context: { queryClient } }) =>
    queryClient
      .ensureQueryData({
        queryKey: notificationKeys.unreadCount(),
        queryFn: () => getUnreadCount(),
      })
      .catch(() => undefined),
  // `pendingMs: 0` / `pendingMinMs: 0` — no debounce, no artificial display
  // floor (see `routes/email-accounts.$id.tsx` for the precedent/rationale).
  pendingComponent: NotificationsPendingState,
  pendingMs: 0,
  pendingMinMs: 0,
  component: lazyRouteComponent(
    () => import('@/features/notifications/NotificationsPage'),
    'NotificationsPage',
  ),
});
